import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Container, Row, Col, Card, CardBody, Button, Table } from "reactstrap"
import Select from "react-select"
import api from "../../services/api"
import Swal from "sweetalert2"
import AuthService from "../../services/Auth.service"
import {
  ordenarOS,
  sortIndicator as sortIndicatorLogic,
  formatarDataExibicao,
  corDoStatus,
  filtrarOS,
  processarOrdensServico as processarOrdensServicoLogic,
  podeEditar as podeEditarOS,
} from "./osLogic"
import { selectMenuStyles } from "./osHelpers"
import StatusBadge from "./components/StatusBadge"
import BotaoAcao from "./components/BotaoAcao"
import MiniStatsCard from "./components/MiniStatsCard"
import FilterBarOS from "./components/FilterBarOS"
import ModalFormOS from "./components/ModalFormOS"
import TipoServicoModal from "./components/TipoServicoModal"

const ListaOS = () => {
  const navigate = useNavigate()
  const user = AuthService.getCurrentUser()

  const [ordensServico, setOrdensServico] = useState([])
  const [filteredOS, setFilteredOS] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")
  const [filterStatus, setFilterStatus] = useState("")
  const [filterTipo, setFilterTipo] = useState("")
  const [filterCondominio, setFilterCondominio] = useState("")
  const [filterDataInicio, setFilterDataInicio] = useState("")
  const [filterDataFim, setFilterDataFim] = useState("")
  const [modalDetalhes, setModalDetalhes] = useState(false)
  const [osDetalhes, setOsDetalhes] = useState(null)
  const [modalNovoTipo, setModalNovoTipo] = useState(false)
  const [novoTipoServico, setNovoTipoServico] = useState("")
  const [tiposServicoAPI, setTiposServicoAPI] = useState([])

  // Estados para modal de edição
  const [modalEditar, setModalEditar] = useState(false)
  const [osEditando, setOsEditando] = useState(null)
  const [editStatus, setEditStatus] = useState("")
  const [editDescricao, setEditDescricao] = useState("")
  const [editItem, setEditItem] = useState("")
  const [editResponsavel, setEditResponsavel] = useState("")
  const [salvandoEdicao, setSalvandoEdicao] = useState(false)

  const [condominios, setCondominios] = useState([])
  const [ordensServicoRaw, setOrdensServicoRaw] = useState([])
  const [dadosCarregados, setDadosCarregados] = useState(false)

  // Paginação e ordenação
  const pageSize = 50
  const [currentPage, setCurrentPage] = useState(1)
  const [sortField, setSortField] = useState("data")
  const [sortDir, setSortDir] = useState("desc")

  useEffect(() => {
    carregarDadosIniciais()
  }, [])

  // Volta para a primeira página sempre que um filtro mudar
  useEffect(() => {
    setCurrentPage(1)
  }, [
    searchTerm,
    filterStatus,
    filterTipo,
    filterCondominio,
    filterDataInicio,
    filterDataFim,
  ])

  // Quando os dados auxiliares carregarem, processar as OS
  useEffect(() => {
    if (
      tiposServicoAPI.length > 0 ||
      condominios.length > 0 ||
      dadosCarregados
    ) {
      processarOrdensServico()
    }
  }, [tiposServicoAPI, condominios, ordensServicoRaw, dadosCarregados])

  useEffect(() => {
    aplicarFiltros()
  }, [
    searchTerm,
    filterStatus,
    filterTipo,
    filterCondominio,
    filterDataInicio,
    filterDataFim,
    ordensServico,
  ])

  const carregarDadosIniciais = async () => {
    setLoading(true)

    try {
      // Carregar tipos e condominios primeiro
      const [tiposRes, condominiosRes] = await Promise.all([
        api.get("/gl_tipo").catch(() => ({ data: [] })),
        api.get("/empresa/").catch(() => ({ data: [] })),
      ])

      setTiposServicoAPI(ordenarTiposRecentes(tiposRes.data))
      setCondominios(condominiosRes.data)

      // Depois carregar as OS
      await carregarOrdensServico()

      setDadosCarregados(true)
    } catch (error) {
      console.error("Erro ao carregar dados iniciais:", error)
      setLoading(false)
    }
  }
  const carregarOrdensServico = async () => {
    console.log("=== Carregando todas as Ordens de Serviço ===")

    // Carregar todas as OS sem filtro por empresa
    const endpoint = `/os`
    console.log("=== Chamando API:", endpoint)

    try {
      const response = await api.get(endpoint)
      console.log("✅ Resposta da API /os:", response.data)
      console.log("📊 Total de OS encontradas:", response.data.length)
      console.log("🔍 Primeiro item:", response.data[0])

      // Salvar dados brutos para processamento posterior
      setOrdensServicoRaw(response.data)
    } catch (error) {
      console.error("❌ Erro ao carregar ordens de serviço:", error)
      console.error("Detalhes do erro:", error.response?.data)
      setOrdensServicoRaw([])
      setOrdensServico([])
      setFilteredOS([])
      setLoading(false)
    }
  }

  // Processar ordens de serviço quando dados auxiliares estiverem disponíveis
  const processarOrdensServico = () => {
    const dadosMapeados = processarOrdensServicoLogic(
      ordensServicoRaw,
      tiposServicoAPI,
      condominios,
    )
    setOrdensServico(dadosMapeados)
    setFilteredOS(dadosMapeados)
    setLoading(false)
  }

  const aplicarFiltros = () => {
    setFilteredOS(
      filtrarOS(ordensServico, {
        searchTerm,
        filterStatus,
        filterTipo,
        filterCondominio,
        filterDataInicio,
        filterDataFim,
      }),
    )
  }

  const formatarDataBR = formatarDataExibicao

  const getStatusBadge = corDoStatus

  const visualizarDetalhes = os => {
    setOsDetalhes(os)
    setModalDetalhes(true)
  }

  const editarOS = os => {
    setOsEditando(os)
    setEditStatus(
      os.status === "Em aberto"
        ? "ABERTO"
        : os.status === "Em andamento"
          ? "ANDAMENTO"
          : os.status === "Concluída"
            ? "CONCLUIDA"
            : "CANCELADA",
    )
    setEditDescricao(os.descricao || "")
    setEditItem(os.item || "")
    setEditResponsavel(os.responsavelTecnico || "")
    setModalEditar(true)
  }

  const fecharModalEditar = () => {
    setModalEditar(false)
    setOsEditando(null)
    setEditStatus("")
    setEditDescricao("")
    setEditItem("")
    setEditResponsavel("")
  }

  const salvarEdicaoOS = async () => {
    if (!osEditando) return

    setSalvandoEdicao(true)

    try {
      // Incluir TIPO_ORDEM obrigatoriamente (a API exige)
      const dadosAtualizados = {
        STATUS: editStatus, // Status no campo STATUS
        PROTOCOLO: osEditando.protocolo, // Protocolo no campo PROTOCOLO
        DS_ORDEM: editDescricao,
        DS_ITEM: editItem,
        RESPONSAVEL: editResponsavel,
        TIPO_ORDEM: osEditando.tipoOrdemId, // Campo obrigatório pela API
      }

      await api.put(`/os/${osEditando.id}`, dadosAtualizados)

      Swal.fire({
        icon: "success",
        title: "OS atualizada!",
        text: "A Ordem de Serviço foi atualizada com sucesso.",
        timer: 2000,
        showConfirmButton: false,
      })

      fecharModalEditar()

      // Recarregar dados
      carregarDadosIniciais()
    } catch (error) {
      console.error("Erro ao atualizar OS:", error)
      Swal.fire({
        icon: "error",
        title: "Erro ao atualizar",
        text:
          error.response?.data?.message ||
          "Não foi possível atualizar a Ordem de Serviço.",
      })
    } finally {
      setSalvandoEdicao(false)
    }
  }

  const excluirOS = os => {
    const id = os.id
    Swal.fire({
      title: "Excluir Ordem de Serviço?",
      html: `Você está prestes a excluir a OS <strong>${
        os.protocolo || id
      }</strong>.<br/>Esta ação não pode ser desfeita.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, excluir!",
      cancelButtonText: "Cancelar",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          // A tabela OS_ANEXO referencia OID_OS e o backend não faz cascade,
          // então excluir a OS direto gera "Foreign key violation". Removemos
          // os anexos primeiro (pode não haver) e só então excluímos a OS.
          let anexosDaOS = []
          try {
            const resp = await api.get(`/os_anexo/os/${id}`)
            anexosDaOS = Array.isArray(resp.data) ? resp.data : []
          } catch (e) {
            anexosDaOS = []
          }
          await Promise.all(
            anexosDaOS.map(a => api.delete(`/os_anexo/${a.OID_ANEXO}`)),
          )
          await api.delete(`/os/${id}`)
          setOrdensServico(ordensServico.filter(o => o.id !== id))
          Swal.fire("Excluída!", "A Ordem de Serviço foi excluída.", "success")
        } catch (error) {
          console.error("Erro ao excluir OS:", error)
          Swal.fire(
            "Erro!",
            "Não foi possível excluir a Ordem de Serviço.",
            "error",
          )
        }
      }
    })
  }

  const limparFiltros = () => {
    setSearchTerm("")
    setFilterStatus("")
    setFilterTipo("")
    setFilterCondominio("")
    setFilterDataInicio("")
    setFilterDataFim("")
  }

  // Tipos de serviço carregados da API GL_TIPO

  const toggleModalNovoTipo = () => {
    setModalNovoTipo(!modalNovoTipo)
    if (!modalNovoTipo) {
      setNovoTipoServico("")
    }
  }

  // Ordena os tipos pelos criados mais recentes primeiro (OID_TIPO é sequencial).
  const ordenarTiposRecentes = lista =>
    [...lista].sort((a, b) => b.OID_TIPO - a.OID_TIPO)

  const carregarTiposServico = async () => {
    try {
      const res = await api.get("/gl_tipo")
      setTiposServicoAPI(ordenarTiposRecentes(res.data))
    } catch (error) {
      console.error("Erro ao carregar tipos:", error)
    }
  }

  const salvarNovoTipo = async () => {
    if (!novoTipoServico.trim()) {
      Swal.fire({
        icon: "warning",
        text: "Digite o nome do novo tipo de serviço",
      })
      return
    }

    // Verificar se já existe
    if (
      tiposServicoAPI.some(
        t => t.NAME.toLowerCase() === novoTipoServico.trim().toLowerCase(),
      )
    ) {
      Swal.fire({
        icon: "warning",
        text: "Este tipo de serviço já existe",
      })
      return
    }

    // Criar novo tipo via API
    try {
      await api.post("/gl_tipo", { NAME: novoTipoServico.trim() })
      Swal.fire({
        icon: "success",
        title: "Tipo de serviço criado!",
        text: `"${novoTipoServico}" foi adicionado com sucesso`,
        timer: 2000,
        showConfirmButton: false,
      })
      // Mantém o modal aberto e limpa o campo para cadastrar o próximo tipo.
      setNovoTipoServico("")
      carregarTiposServico() // Recarregar lista
    } catch (error) {
      console.error("Erro ao criar tipo de serviço:", error)
      Swal.fire({
        icon: "error",
        title: "Erro ao criar tipo",
        text: "Não foi possível criar o tipo de serviço. Tente novamente.",
      })
    }
  }

  const editarTipoServico = async (oidTipo, novoNome) => {
    // Bloqueia nome duplicado (ignorando o próprio tipo em edição)
    if (
      tiposServicoAPI.some(
        t =>
          t.OID_TIPO !== oidTipo &&
          t.NAME.toLowerCase() === novoNome.toLowerCase(),
      )
    ) {
      Swal.fire({
        icon: "warning",
        text: "Já existe um tipo de serviço com esse nome",
      })
      return
    }

    try {
      await api.put(`/gl_tipo/${oidTipo}`, { NAME: novoNome })
      Swal.fire({
        icon: "success",
        title: "Tipo de serviço atualizado!",
        timer: 1500,
        showConfirmButton: false,
      })
      carregarTiposServico()
    } catch (error) {
      console.error("Erro ao atualizar tipo de serviço:", error)
      Swal.fire({
        icon: "error",
        title: "Erro ao atualizar",
        text: "Não foi possível atualizar o tipo de serviço. Tente novamente.",
      })
    }
  }

  const excluirTipoServico = tipo => {
    Swal.fire({
      title: "Excluir tipo de serviço?",
      html: `Tem certeza que deseja excluir <strong>"${tipo.NAME}"</strong>?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
    }).then(async result => {
      if (!result.isConfirmed) return
      try {
        await api.delete(`/gl_tipo/${tipo.OID_TIPO}`)
        Swal.fire({
          icon: "success",
          title: "Excluído!",
          timer: 1500,
          showConfirmButton: false,
        })
        carregarTiposServico()
      } catch (error) {
        console.error("Erro ao excluir tipo de serviço:", error)
        Swal.fire({
          icon: "error",
          title: "Erro ao excluir",
          text: "Não foi possível excluir. Pode haver Ordens de Serviço usando este tipo.",
        })
      }
    })
  }

  // Opções para os selects de filtro (react-select), preservando os valores
  // de estado (rótulos PT-BR para status; NAME para tipo).
  const statusFilterOptions = [
    { value: "Em aberto", label: "Em aberto" },
    { value: "Em andamento", label: "Em andamento" },
    { value: "Concluída", label: "Concluída" },
    { value: "Cancelada", label: "Cancelada" },
  ]
  const tipoFilterOptions = tiposServicoAPI
    .filter(t => t.NAME && t.NAME.trim())
    .map(t => ({
      value: t.NAME,
      label: t.NAME,
    }))
  const condominioFilterOptions = condominios.map(c => ({
    value: c.OID_EMPRESA,
    label: c.NM_RAZAO_SOCIAL || c.DS_EMPRESA || `Empresa ${c.OID_EMPRESA}`,
  }))
  const editStatusOptions = [
    { value: "ABERTO", label: "Em aberto" },
    { value: "ANDAMENTO", label: "Em andamento" },
    { value: "CONCLUIDA", label: "Concluída" },
    { value: "CANCELADA", label: "Cancelada" },
  ]

  // Clique nos cards de resumo aplica/limpa o filtro de status
  const filtrarPorStatus = status => {
    setFilterStatus(prev => (prev === status ? "" : status))
  }

  // Ordenação por coluna (alterna asc/desc ao clicar no mesmo cabeçalho)
  const toggleSort = field => {
    if (sortField === field) {
      setSortDir(sortDir === "asc" ? "desc" : "asc")
    } else {
      setSortField(field)
      setSortDir("asc")
    }
  }

  const sortIndicator = field => sortIndicatorLogic(field, sortField, sortDir)

  // Aplica ordenação sobre a lista já filtrada
  const sortedOS = ordenarOS(filteredOS, sortField, sortDir)

  // Paginação
  const totalItens = sortedOS.length
  const totalPaginas = Math.max(1, Math.ceil(totalItens / pageSize))
  const paginaAtual = Math.min(currentPage, totalPaginas)
  const inicio = (paginaAtual - 1) * pageSize
  const pageItems = sortedOS.slice(inicio, inicio + pageSize)
  const exibindoDe = totalItens === 0 ? 0 : inicio + 1
  const exibindoAte = Math.min(inicio + pageSize, totalItens)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Card de filtros + cabeçalho */}
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                    <h4 className="card-title mb-0">Ordens de Serviço</h4>
                    <Button
                      color="primary"
                      onClick={() => navigate("/ordem-servico/criar")}
                    >
                      <i className="bx bx-plus-circle me-1"></i>
                      Nova Ordem de Serviço
                    </Button>
                  </div>

                  <FilterBarOS
                    searchTerm={searchTerm}
                    onSearch={setSearchTerm}
                    statusOptions={statusFilterOptions}
                    filterStatus={filterStatus}
                    onStatus={setFilterStatus}
                    condominioOptions={condominioFilterOptions}
                    filterCondominio={filterCondominio}
                    onCondominio={setFilterCondominio}
                    tipoOptions={tipoFilterOptions}
                    filterTipo={filterTipo}
                    onTipo={setFilterTipo}
                    filterDataInicio={filterDataInicio}
                    onDataInicio={setFilterDataInicio}
                    filterDataFim={filterDataFim}
                    onDataFim={setFilterDataFim}
                    onNovoTipo={toggleModalNovoTipo}
                    onLimpar={limparFiltros}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Resumo (mini-stats no padrão do Dashboard de hml) */}
          <Row>
            <MiniStatsCard
              ativo={filterStatus === "Em aberto"}
              onClick={() => filtrarPorStatus("Em aberto")}
              title="Filtrar por Em aberto"
              label="Em Aberto"
              count={
                ordensServico.filter(os => os.status === "Em aberto").length
              }
              icon="bx bx-time-five"
            />
            <MiniStatsCard
              ativo={filterStatus === "Em andamento"}
              onClick={() => filtrarPorStatus("Em andamento")}
              title="Filtrar por Em andamento"
              label="Em Andamento"
              count={
                ordensServico.filter(os => os.status === "Em andamento").length
              }
              icon="bx bx-loader-alt"
            />
            <MiniStatsCard
              ativo={filterStatus === "Concluída"}
              onClick={() => filtrarPorStatus("Concluída")}
              title="Filtrar por Concluída"
              label="Concluídas"
              count={
                ordensServico.filter(os => os.status === "Concluída").length
              }
              icon="bx bx-check-circle"
            />
            <MiniStatsCard
              ativo={filterStatus === ""}
              onClick={() => setFilterStatus("")}
              title="Mostrar todas (limpar filtro de status)"
              label="Total"
              count={ordensServico.length}
              icon="bx bx-file"
            />
          </Row>

          {/* Tabela */}
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  {loading ? (
                    <div className="text-center py-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="sr-only">Carregando...</span>
                      </div>
                      <p className="mt-3 text-muted">
                        Carregando ordens de serviço...
                      </p>
                    </div>
                  ) : filteredOS.length === 0 ? (
                    <div className="text-center py-5">
                      <i className="bx bx-file font-size-48 text-muted mb-3 d-block"></i>
                      <h5 className="text-muted">
                        Nenhuma ordem de serviço encontrada
                      </h5>
                      <p className="text-muted mb-4">
                        {searchTerm ||
                        filterStatus ||
                        filterTipo ||
                        filterCondominio ||
                        filterDataInicio ||
                        filterDataFim
                          ? "Tente ajustar os filtros de busca"
                          : "Comece criando uma nova ordem de serviço"}
                      </p>
                      <Button
                        color="primary"
                        onClick={() => navigate("/ordem-servico/criar")}
                      >
                        <i className="bx bx-plus me-1"></i>
                        Criar Primeira OS
                      </Button>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <Table className="table align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleSort("protocolo")}
                              title="Ordenar por protocolo"
                            >
                              Protocolo{" "}
                              <i
                                className={`bx ${sortIndicator(
                                  "protocolo",
                                )} align-middle`}
                              ></i>
                            </th>
                            <th
                              className="text-center"
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleSort("data")}
                              title="Ordenar por data"
                            >
                              Data{" "}
                              <i
                                className={`bx ${sortIndicator(
                                  "data",
                                )} align-middle`}
                              ></i>
                            </th>
                            <th
                              className="text-center"
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleSort("status")}
                              title="Ordenar por status"
                            >
                              Status{" "}
                              <i
                                className={`bx ${sortIndicator(
                                  "status",
                                )} align-middle`}
                              ></i>
                            </th>
                            <th>Condomínio</th>
                            <th>Responsável</th>
                            <th>Tipo de Serviço</th>
                            <th className="text-center">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pageItems.map(os => {
                            const podeEditar = podeEditarOS(os.status);
                            return (
                            <tr key={os.id}>
                              <td>
                                <strong className="text-primary">
                                  {os.protocolo}
                                </strong>
                              </td>
                              <td className="text-center">{os.dataAbertura}</td>
                              <td className="text-center">
                                <StatusBadge
                                  color={getStatusBadge(os.status)}
                                  label={os.status}
                                />
                              </td>
                              <td>{os.condominio}</td>
                              <td>
                                <i className="bx bx-user-circle me-1"></i>
                                {os.responsavelTecnico}
                              </td>
                              <td>
                                <i className="bx bx-wrench me-1 text-primary"></i>
                                {os.tipoServico}
                              </td>
                              <td className="text-center">
                                <div className="d-flex justify-content-center gap-2">
                                  <BotaoAcao
                                    iconClassName="bx bx-show align-middle"
                                    onClick={() =>
                                      navigate(`/ordem-servico/${os.id}`)
                                    }
                                    title="Abrir detalhes completos"
                                  />
                                  <BotaoAcao
                                    iconClassName="bx bx-zoom-in align-middle"
                                    onClick={() => visualizarDetalhes(os)}
                                    title="Visualização rápida (resumo)"
                                  />
                                  <BotaoAcao
                                    iconClassName={`bx bx-edit align-middle ${
                                      podeEditar ? "" : "text-muted"
                                    }`}
                                    onClick={() => editarOS(os)}
                                    disabled={!podeEditar}
                                    style={
                                      !podeEditar
                                        ? {
                                            opacity: 0.4,
                                            cursor: "not-allowed",
                                          }
                                        : undefined
                                    }
                                    title={
                                      podeEditar
                                        ? "Editar ordem de serviço"
                                        : "Indisponível — OS concluída/cancelada não pode ser editada"
                                    }
                                  />
                                  <BotaoAcao
                                    iconClassName="bx bx-trash align-middle text-danger"
                                    onClick={() => excluirOS(os)}
                                    title="Excluir ordem de serviço"
                                  />
                                </div>
                              </td>
                            </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      {/* Contador + paginação */}
                      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
                        <span className="text-muted">
                          Mostrando {exibindoDe}–{exibindoAte} de {totalItens}{" "}
                          {totalItens === 1 ? "registro" : "registros"}
                        </span>
                        {totalPaginas > 1 && (
                          <div className="d-flex align-items-center gap-2">
                            <Button
                              color="light"
                              size="sm"
                              disabled={paginaAtual <= 1}
                              onClick={() =>
                                setCurrentPage(Math.max(1, paginaAtual - 1))
                              }
                            >
                              <i className="bx bx-chevron-left"></i> Anterior
                            </Button>
                            <span className="text-muted">
                              Página {paginaAtual} de {totalPaginas}
                            </span>
                            <Button
                              color="light"
                              size="sm"
                              disabled={paginaAtual >= totalPaginas}
                              onClick={() =>
                                setCurrentPage(
                                  Math.min(totalPaginas, paginaAtual + 1),
                                )
                              }
                            >
                              Próxima <i className="bx bx-chevron-right"></i>
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Modal de Detalhes */}
      <ModalFormOS
        isOpen={modalDetalhes}
        toggle={() => setModalDetalhes(false)}
        size="lg"
        title="Detalhes da Ordem de Serviço"
        footer={
          <>
            <Button color="secondary" onClick={() => setModalDetalhes(false)}>
              Fechar
            </Button>
            <Button
              color="primary"
              onClick={() => {
                setModalDetalhes(false)
                navigate(`/ordem-servico/${osDetalhes?.id}`)
              }}
            >
              <i className="bx bx-expand me-1"></i>
              Ver Detalhes Completos
            </Button>
          </>
        }
      >
        {osDetalhes && (
          <div>
            <div className="row">
              <div className="col-md-6">
                <label className="text-muted small">Protocolo</label>
                <p className="text-primary fw-bold">{osDetalhes.protocolo}</p>
              </div>
              <div className="col-md-3">
                <label className="text-muted small">Data de Abertura</label>
                <p>{formatarDataBR(osDetalhes.dataAbertura)}</p>
              </div>
              <div className="col-md-3">
                <label className="text-muted small">Status</label>
                <div>
                  <StatusBadge
                    color={getStatusBadge(osDetalhes.status)}
                    label={osDetalhes.status}
                  />
                </div>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-md-6">
                <label className="text-muted small">Condomínio</label>
                <p>{osDetalhes.condominio}</p>
              </div>
              <div className="col-md-6">
                <label className="text-muted small">Responsável Técnico</label>
                <p>
                  <i className="bx bx-user-circle me-2"></i>
                  {osDetalhes.responsavelTecnico}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <label className="text-muted small">Tipo de Serviço</label>
                <p>
                  <i className="bx bx-wrench me-2 text-primary"></i>
                  {osDetalhes.tipoServico}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <label className="text-muted small">Descrição</label>
                <p>{osDetalhes.descricao}</p>
              </div>
            </div>

            {osDetalhes.equipamentos && osDetalhes.equipamentos.length > 0 && (
              <>
                <hr />
                <label className="text-muted small mb-3 d-block">
                  <i className="bx bx-package me-2"></i>
                  Equipamentos Entregues
                </label>
                <div className="table-responsive">
                  <Table className="table align-middle table-sm mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Modelo / Device</th>
                        <th className="text-center">Quantidade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {osDetalhes.equipamentos.map((eq, index) => (
                        <tr key={index}>
                          <td>{eq.modelo}</td>
                          <td className="text-center">
                            <span className="badge bg-primary">
                              {eq.quantidade} un.
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}

            {osDetalhes.assinatura && (
              <>
                <hr />
                <label className="text-muted small mb-3 d-block">
                  <i className="bx bx-edit-alt me-2"></i>
                  Assinatura do Cliente
                </label>
                <div className="text-center">
                  <div className="border rounded p-3 d-inline-block bg-white">
                    <img
                      src={osDetalhes.assinatura}
                      alt="Assinatura"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </ModalFormOS>

      {/* Modal Novo Tipo de Serviço */}
      <TipoServicoModal
        isOpen={modalNovoTipo}
        toggle={toggleModalNovoTipo}
        valor={novoTipoServico}
        onChange={setNovoTipoServico}
        onSalvar={salvarNovoTipo}
        tipos={tiposServicoAPI}
        onEditarTipo={editarTipoServico}
        onExcluirTipo={excluirTipoServico}
      />

      {/* Modal Editar OS */}
      <ModalFormOS
        isOpen={modalEditar}
        toggle={fecharModalEditar}
        size="lg"
        title={
          <>
            Editar Ordem de Serviço
            {osEditando && (
              <span className="text-primary ms-2">{osEditando.protocolo}</span>
            )}
          </>
        }
        footer={
          <>
            <Button
              color="secondary"
              onClick={fecharModalEditar}
              disabled={salvandoEdicao}
            >
              Cancelar
            </Button>
            <Button
              color="primary"
              onClick={salvarEdicaoOS}
              disabled={salvandoEdicao}
            >
              {salvandoEdicao ? (
                <>
                  <i className="bx bx-loader-alt bx-spin me-1"></i>
                  Salvando...
                </>
              ) : (
                <>
                  <i className="bx bx-save me-1"></i>
                  Salvar Alterações
                </>
              )}
            </Button>
          </>
        }
      >
        {osEditando && (
          <div>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">
                  <i className="bx bx-flag me-1"></i>
                  Status <span className="text-danger">*</span>
                </label>
                <Select
                  options={editStatusOptions}
                  value={
                    editStatusOptions.find(o => o.value === editStatus) || null
                  }
                  onChange={opt => setEditStatus(opt ? opt.value : "")}
                  styles={selectMenuStyles}
                />
              </div>
              <div className="col-md-6 mt-2 mt-md-0">
                <label className="form-label">
                  <i className="bx bx-user me-1"></i>
                  Responsável Técnico
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={editResponsavel}
                  onChange={e => setEditResponsavel(e.target.value)}
                  placeholder="Nome do responsável"
                />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-md-6">
                <label className="form-label">
                  <i className="bx bx-package me-1"></i>
                  Item / Quantidade
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={editItem}
                  onChange={e => setEditItem(e.target.value)}
                  placeholder="Ex: 5"
                />
              </div>
              <div className="col-md-6 mt-2 mt-md-0">
                <label className="form-label text-muted">
                  <i className="bx bx-building me-1"></i>
                  Condomínio
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={osEditando.condominio}
                  disabled
                />
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-md-12">
                <label className="form-label">
                  <i className="bx bx-text me-1"></i>
                  Descrição
                </label>
                <textarea
                  className="form-control"
                  rows={4}
                  value={editDescricao}
                  onChange={e => setEditDescricao(e.target.value)}
                  placeholder="Descrição do serviço..."
                />
              </div>
            </div>
          </div>
        )}
      </ModalFormOS>
    </React.Fragment>
  )
}

export default ListaOS
